import * as yup from 'yup';


const schemas = {
	
	owner : yup.object().shape({
		id: yup.number(),
		firstName:  yup.string().nullable(true).when('lastName', {
			is:  (a)=>!!a,
			then: () => yup.string().required(),
			otherwise: () => yup.string(),
        }).when(['id', 'companyName'], {
			is:  (a, b)=> !a&&!b,
			then: () => yup.string().required(),
			otherwise: () => yup.string(),
        }).when('companyName', {
			is:  (a)=>!a,
			then: () => yup.string().required(),
			otherwise: () => yup.string(),
        }),
		lastName: yup.string().nullable(true).when('firstName', {
			is: (a)=>!!a,
			then: () => yup.string().required(),
			otherwise: () => yup.string(),
        }),
		companyName: yup.string().nullable(true),
		email: yup.string().nullable(false).email(),
		zipcode: yup.string().when(['city','street'], {
			is: (a, b)=>!!a||!!b,
			then: () => yup.string().min(3).required(),
			otherwise: () => yup.string(),
        }),
		street: yup.string().when(['city','zipcode'], {
			is: (a, b)=>!!a||!!b,
			then: () => yup.string().min(3).required(),
			otherwise: () => yup.string(),
        }),
		city: yup.string().when(['street','zipcode'], {
			is: (a, b)=>!!a||!!b,
			then: () => yup.string().required(),
			otherwise: () => yup.string(),
        }),
		country: yup.string().required(),
        
	}, [
		["lastName", "firstName", "companyName"], 
		["zipcode", "city"], 
		["zipcode", "street"], 
		["street", "city"]
	]).noUnknown(true),
	
	project : yup.object().shape({
		name: yup.string().min(3).required(),
		country: yup.string().required(),
		energyTypes: yup.array().min(1).required(),

	}).noUnknown(true),
	projectSettings : yup.object().shape({
		name: yup.string().min(3).required(),
		phase: yup.string().required(),
		state: yup.string().required(),
		projectOwnerObj: yup.object().required(),

	}).noUnknown(true),
	download : yup.object().shape({
		layers: yup.array().min(1, "Please select at least one layer").required(),

	}).noUnknown(true),
	
	note : yup.object().shape({
		text: yup.string().required(),
	}).noUnknown(true),
	
	dialog : yup.object().shape({
		dialogType: yup.string().required(),
		text: yup.string().required(),
	}).noUnknown(true),
	
	projectState : yup.object().shape({
		state: yup.string().required(),
		log: yup.string().required(),
	}).noUnknown(true),
	
	settings : yup.object().shape({
		firstName: yup.string().min(3).required(),
		lastName: yup.string().required(),

	}).noUnknown(true),
	
	scenario : yup.object().shape({
		name: yup.string().min(3).required()

	}).noUnknown(true),
	
	setmain : yup.object().shape({
		message: yup.string().min(15, "Please write at least 15 characters").required(),

	}).noUnknown(true),
	
	libraryLayer : yup.object().shape({
		name: yup.string().min(3).required(),

	}).noUnknown(true),
	
	color : yup.object().shape({
		color: yup.string().min(7).required(),

	}).noUnknown(true),
	
	sandboxMap : yup.object().shape({
		title: yup.string().min(3).required(),

	}).noUnknown(true),
	
	propertyAttribute : yup.object({
		key: yup.string().required(),
		value: yup.string().required(),

	}),
	buffer : yup.object({
		name: yup.string().required(),
		buffer: yup.number().required(),

	}),
	annotation : yup.object({
		text: yup.string().required(),
	}),
	
	
	
	
	unknownOwner: {
		fullName:'(Unknown)',
		properties:[],
		totalArea:0,
		dialogs:[],
		unknown:true,
		id:'temp_'
	}
}

export default schemas;
